import React, { useEffect } from 'react';
import { TopBanner } from '../components/TopBanner';
import { HeroSection } from '../components/HeroSection';
import { OpeningHookSection } from '../components/OpeningHookSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedAttemptsSection } from '../components/FailedAttemptsSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoIsForSection } from '../components/WhoIsForSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-maternal-cream font-body text-maternal-brown overflow-x-hidden pt-8" data-id="element-254">
      <TopBanner data-id="element-255" />
      <HeroSection data-id="element-256" />
      <OpeningHookSection data-id="element-257" />
      <ProblemSection data-id="element-258" />
      <FailedAttemptsSection data-id="element-259" />
      <MechanismSection data-id="element-260" />
      <WhatYouGetSection data-id="element-261" />
      <WhoIsForSection data-id="element-262" />
      <HowItWorksSection data-id="element-263" />
      <TestimonialsSection data-id="element-264" />
      <FAQSection data-id="element-265" />
      <OfferSection data-id="element-266" />
      <Footer data-id="element-267" />
      <PurchaseNotifications data-id="element-268" />
    </div>;
}